import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CommandRegistryContext } from "../../components/CommandPaletteRegistry";

/**
 * Route for /staff/id/:id.
 * Opens the Goto ID dialog with the param value.
 * The openGotoId callback is stable (useCallback with []) so
 * this effect only re-fires when the :id param changes (e.g. back/forward).
 */
export function GotoIdRoute() {
  const { id } = useParams<{ id: string }>();
  const openGotoId = useContext(CommandRegistryContext)?.openGotoId;

  useEffect(() => {
    if (id) {
      openGotoId?.(id);
    }
  }, [id, openGotoId]);

  return null;
}
